import VehicleImageSwiper from "./VehicleImageSwiper";

export default VehicleImageSwiper;
